import { isEnabled } from "lib/@components/feature"
import { hasDemand } from "lib/authorization/has-demand"
import { registerFeature } from "lib/features"
import { registerConditionalPageNavigation } from "lib/routes/register-conditional-page-navigation"
import DemandGuard from "minimals-template/components/guards/DemandGuard"
import { authoringRoute } from "authoring/routes/authoring.runtime"
import { appRoute } from "routes/app/home.runtime"
import { FEATURE_FLAG_PROJECT_BRIDGE, PROJECT_BRIDGE_ACCESS_DEMAND } from "./server/feature-flag-project-bridge.mjs"
import { getProjectBridgeRootPath } from "./project-bridge-route-paths"
import { ProjectBridgeDetailPage } from "./project-bridge-detail-page"
import { ProjectBridgeListPage } from "./project-bridge-list-page"

registerFeature({
    numericalId: 5002,
    id: FEATURE_FLAG_PROJECT_BRIDGE,
    name: "Project Bridge",
    description: "Review copied schedule overlap evidence and stage Project Bridge rewrites.",
    internalUseOnly: true,
})

const projectBridgeDemands = ["user", `$feature-${FEATURE_FLAG_PROJECT_BRIDGE}`, PROJECT_BRIDGE_ACCESS_DEMAND]

appRoute.register(
    "project-bridge",
    <DemandGuard demands={projectBridgeDemands} and>
        <ProjectBridgeListPage $lazy />
    </DemandGuard>
)
authoringRoute.register(
    "project-bridge",
    <DemandGuard demands={projectBridgeDemands} and>
        <ProjectBridgeListPage $lazy />
    </DemandGuard>
)

appRoute.register(
    "project-bridge/:id",
    <DemandGuard demands={projectBridgeDemands} and>
        <ProjectBridgeDetailPage $lazy />
    </DemandGuard>
)
authoringRoute.register(
    "project-bridge/:id",
    <DemandGuard demands={projectBridgeDemands} and>
        <ProjectBridgeDetailPage $lazy />
    </DemandGuard>
)

registerConditionalPageNavigation(
    canAccessProjectBridge,
    getProjectBridgeRootPath("app"),
    "Project Bridge",
    "mdi:bridge",
    {
        group: "More",
        priority: 257,
        subPaths: true,
    }
)

registerConditionalPageNavigation(
    canAccessProjectBridge,
    getProjectBridgeRootPath("authoring"),
    "Project Bridge",
    "mdi:bridge",
    {
        group: "More",
        priority: 257,
        subPaths: true,
    }
)
function canAccessProjectBridge() {
    return isEnabled(FEATURE_FLAG_PROJECT_BRIDGE) && hasDemand("user") && hasDemand(PROJECT_BRIDGE_ACCESS_DEMAND)
}
